import { useEffect } from "react";
import { socketClient } from "../socket/socket.client";

// Global flag to track if socket has been initialized
let socketInitialized = false;

export function useSocket() {
  useEffect(() => {
    // Only connect once when the app starts, not on every component mount
    if (!socketInitialized) {
      socketClient.connect();
      socketInitialized = true;
    }

    // Don't disconnect on unmount - keep connection alive across navigation
    // Socket will only disconnect when the app is closed or explicitly disconnected
  }, []);

  return socketClient;
}
